const handleTypeSelect = (component) => (e, index) => {
    $(component).data('typeIndex', index);
};

export default handleTypeSelect;



// WEBPACK FOOTER //
// ./src/scripts/components/search/handleTypeSelect.js